export const BackgroundTypeEnum = {
    Body: 1,
    Footer: 2
};

export const BackgroundFitTypeEnum = {
    Fill: 1,
    Repeat: 2,
    Fit: 3
};


export const BackgroundPositionEnum = {
    Standard: 1,
    Fixed: 2
}; 